var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            width: "1400px",
            "custom-class": "action-detail-dialog",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            }
          }
        },
        [
          _c("template", { slot: "title" }, [
            _c("div", { staticClass: "action-detail-header" }, [
              _c("span", { staticClass: "action-detail-header__title" }, [
                _vm._v(_vm._s(_vm.componentTitle))
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.detailLoading
            ? _c(
                "div",
                { staticClass: "action-detail-skeleton" },
                [
                  _c(
                    "div",
                    { staticClass: "skeleton-buttons" },
                    [
                      _c(
                        "el-skeleton",
                        { attrs: { rows: 0, animated: "" } },
                        [
                          _c("template", { slot: "template" }, [
                            _c(
                              "div",
                              { staticClass: "skeleton-button-row" },
                              [
                                _c("el-skeleton-item", {
                                  staticStyle: {
                                    width: "120px",
                                    height: "32px"
                                  },
                                  attrs: { variant: "button" }
                                }),
                                _vm._v(" "),
                                _c("el-skeleton-item", {
                                  staticStyle: {
                                    width: "140px",
                                    height: "32px"
                                  },
                                  attrs: { variant: "button" }
                                }),
                                _vm._v(" "),
                                _c("el-skeleton-item", {
                                  staticStyle: {
                                    width: "120px",
                                    height: "32px"
                                  },
                                  attrs: { variant: "button" }
                                }),
                                _vm._v(" "),
                                _c("el-skeleton-item", {
                                  staticStyle: {
                                    width: "140px",
                                    height: "32px"
                                  },
                                  attrs: { variant: "button" }
                                })
                              ],
                              1
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.skeletonMainPanelWidth } },
                        [
                          _c(
                            "el-skeleton",
                            { attrs: { rows: 0, animated: "" } },
                            [
                              _c(
                                "template",
                                { slot: "template" },
                                [
                                  _c("el-skeleton-item", {
                                    staticStyle: {
                                      width: "100%",
                                      height: "900px"
                                    },
                                    attrs: { variant: "rect" }
                                  })
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.skeletonRightPanelWidth > 0
                        ? _c(
                            "el-col",
                            { attrs: { span: _vm.skeletonRightPanelWidth } },
                            [
                              _c(
                                "el-skeleton",
                                { attrs: { rows: 0, animated: "" } },
                                [
                                  _c(
                                    "template",
                                    { slot: "template" },
                                    [
                                      _c("el-skeleton-item", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "900px"
                                        },
                                        attrs: { variant: "rect" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _c("action-detail", {
                ref: "actionDetail",
                attrs: {
                  "initial-action": _vm.selectedAction,
                  "component-type": _vm.componentType,
                  "on-action-changed": _vm.handleActionChanged
                },
                scopedSlots: _vm._u(
                  [
                    _vm.queueActive
                      ? {
                          key: "extra-actions",
                          fn: function() {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    disabled:
                                      !_vm.queueHasNext || _vm.navigating
                                  },
                                  on: { click: _vm.navigateNext }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t" +
                                      _vm._s(_vm.$t("next")) +
                                      "\n\t\t\t\t"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "queue-position-inline" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.queuePosition) +
                                      " / " +
                                      _vm._s(_vm.queueLength)
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      : null
                  ],
                  null,
                  true
                )
              })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }